import { useEffect } from "react";
import seoData from "../data/seoPages.json";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || seoData.siteUrl).replace(/\/$/, "");
const DEFAULT_IMAGE = `${SITE_URL}/Images/suite1-hero.png`;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/** Sets title, description, canonical, Open Graph, Twitter and JSON-LD for the current route. */
export default function Seo({ title, description, path = "/", image = DEFAULT_IMAGE, noindex = false, jsonLd = [] }) {
  const ldKey = JSON.stringify(jsonLd);
  useEffect(() => {
    const url = path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large");
    setLink("canonical", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "ROOM XIII");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    document.head.querySelectorAll("script[data-seo-ld]").forEach((n) => n.remove());
    JSON.parse(ldKey).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-ld", "1");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
    return () => document.head.querySelectorAll("script[data-seo-ld]").forEach((n) => n.remove());
  }, [title, description, path, image, noindex, ldKey]);
  return null;
}

export const lodgingSchema = {
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  name: "ROOM XIII",
  description: "Private luxury boutique stay for couples in Zirakpur, Punjab.",
  url: SITE_URL,
  image: DEFAULT_IMAGE,
  telephone: "+917018595304",
  email: "contact@roomxiii.com",
  priceRange: "₹500+",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Patiala Road",
    addressLocality: "Zirakpur",
    addressRegion: "Punjab",
    addressCountry: "IN",
  },
  areaServed: ["Zirakpur", "Chandigarh", "Mohali", "Panchkula"],
  sameAs: ["https://www.instagram.com/official_roomxiii"],
};

/** Structured data built from the admin-editable contact details. */
export function buildLodgingSchema(get) {
  const addr = String(get("site.address") || "").split("\n").map((x) => x.trim()).filter(Boolean);
  return {
    ...lodgingSchema,
    telephone: get("site.phone_link"),
    email: get("site.email"),
    address: { ...lodgingSchema.address, streetAddress: addr[0] || lodgingSchema.address.streetAddress },
    sameAs: [String(get("site.instagram_url") || "").split("?")[0]].filter(Boolean),
  };
}
